import { render } from "./MediaVolumeControl.vue?vue&type=template&id=36e057f2"
import script from "./MediaVolumeControl.vue?vue&type=script&lang=js"
export * from "./MediaVolumeControl.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__